export default __webpack_public_path__ + "arrowhead-pointing-up-inside-a-square-box-outline.png";